/** 本地存储键：与对标产品保持一致，方便后续迁移与对照 */
export const AUTH_CARD_KEY = 'card_key';
export const AUTH_SESSION_KEY = 'session_token';
export const AUTH_USER_ID_KEY = 'user_id';
export const AUTH_DEVICE_KEY = 'device_id';
export const SESSION_RECORD_KEY = 'userLoginData';
export const SKIN_KEY_PREFIX = 'luogen:skin:v1';
